import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Config} from './../config/config.service';
import {AppState} from '../../NGRX/core.state';
import {selectMicrositeSessions} from '../../NGRX/coreAuth/coreAuth.selectors';
import {select, Store} from '@ngrx/store';
import {Subject} from "rxjs";
import {map, take} from "rxjs/operators";

@Injectable()
export class FreeplayRouteGuard {
    private rootUrl: string;
    private skipVerifyAge: boolean;
    public ngDestroyed$ = new Subject();

    constructor(
        private config: Config,
        private router: Router,
        private store: Store<AppState>
    ) {
        this.rootUrl = this.config.CONFIG.rootUrl;
        this.skipVerifyAge = this.config.CONFIG.skipVerifyAge;
    }

    canActivate() {
        const isAgeVerified = true;
        if (this.skipVerifyAge) {
            return this.checkEnabled(isAgeVerified);
        }
        return this.store.pipe(
            select(selectMicrositeSessions),
            map(data => this.handleSessionData(data, isAgeVerified)),
            take(1)
        )
    }

    checkEnabled(isAgeVerified: boolean): boolean {
        if (this.config.CONFIG.enableFreeplay && isAgeVerified) {
            return true;
        }
        this.router.navigate([this.rootUrl]);
        return false;
    }

    private handleSessionData(data: any, isAgeVerified: boolean): boolean {
        if (!!data.ext_id) {
            isAgeVerified = data.age_verified;
            return this.checkEnabled(isAgeVerified);
        } else {
            return false;
        }
    }
}
